import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import { Dropdown, Icon } from "@fluentui/react";
import Dependency from "../Assets/icons/Dependency.svg";
import { Snackbar, Alert, CircularProgress, Backdrop } from "@mui/material";
const CloudProSVConfig = ({
  svList,
  setSvList,
 selectedSV,
  onSave,

  onClose,
  selectedCell, updateSV
}) => {
  const [project, setProject] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem("selectedProject")) || null;
    } catch { return null; }
  });
  useEffect(() => {
    const refresh = () => {
      try {
        const fresh = JSON.parse(sessionStorage.getItem("selectedProject"));
        if (fresh) setProject(fresh);
      } catch { }
    };
    refresh();
    window.addEventListener("storage", refresh);
    return () => window.removeEventListener("storage", refresh);
  }, []);
  const getDependency = (proj) => {
    return (
      proj?.panel?.VT5000_CONFIG?.Dependency ||
      proj?.panel?.VT5000_CONFIG?.dependency ||
      []
    );
  };
  const panelAddress =
    project?.panel?.VT5000_CONFIG?.panelAddress ||
    project?.panel?.VT5000_CONFIG?.generalparameters?.panelAddress ||
    project?.panel?.VT5000_CONFIG?.GeneralParameters?.panelAddress ||
    0;


  const svListRef = useRef(svList);

  const [localSelectedSV, setLocalSelectedSV] = useState(0);
  const localSelectedSVRef = useRef(0);

  
  useEffect(() => {
    svListRef.current = svList;
  }, [svList]);

  useEffect(() => {
    localSelectedSVRef.current = localSelectedSV;
  }, [localSelectedSV]);
useEffect(() => {
  if (!selectedSV || svList.length === 0) return;

  let targetIndex = svList.findIndex((sv) => sv.name === selectedSV);

  if (targetIndex === -1) {
    const match = selectedSV.match(/\d+/);
    if (match) {
      const num = Number(match[0]) - 1;
      if (num >= 0 && num < svList.length) targetIndex = num;
    }
  }

  if (targetIndex !== -1) {
    setLocalSelectedSV(targetIndex);
  }
}, [selectedSV, svList.length]);
 useEffect(() => {
  if (!project) return;

  
  if (svList.length > 0) return;

  const dependencyArray =
    project?.selectedPanel?.VT5000_CONFIG?.Dependency ||
    project?.selectedPanel?.VT5000_CONFIG?.dependency ||
    project?.panel?.VT5000_CONFIG?.Dependency ||
    project?.panel?.VT5000_CONFIG?.dependency ||
    [];

  console.log("Dependency Array:", dependencyArray);

  const existingSVs = dependencyArray
    .map((dep, index) => ({ dep, index }))
   .filter(({ dep }) =>
  dep?.dependencyType === 1 ||
  dep?.dependencyType === 2 ||
  dep?.dependencyType === 3
)
    .map(({ dep, index }, i) => {
  const type = dep.dependencyType;
  const base = {
    id: Date.now() + i,
    name: `SV${i + 1}`,
    dependencyIndex: index,
    dependencyType: type,
  };

  if (type === 1 || type === 2) {
    return {
      ...base,
      inhibitionPeriod: dep.information_field1 || 10,
      smartVerifyPeriod: dep.information_field2 || 1,
      includedZoneFrom: dep.information_field3 || 1,
      includedZoneTo: dep.information_field4 || 1,
      firstFireOutputFrom: dep.information_field5 || 1,
      firstFireOutputTo: dep.information_field6 || 1,
      outputFrom: dep.information_field5 || 1,
      outputTo: dep.information_field6 || 1,
    };
  }

  // type === 3
  return {
    ...base,
    zone1: String(dep.information_field1 || ""),
    zone2: String(dep.information_field2 || ""),
    d1: dep.information_field3 || 0,
    d2: dep.information_field4 || 0,
    outD1R1From: String(dep.information_field5 || ""),
    outD1R1To: String(dep.information_field6 || ""),
    outD2R1From: String(dep.information_field7 || ""),
    outD2R1To: String(dep.information_field8 || ""),
    secondR1From: String(dep.information_field9 || ""),
    secondR1To: String(dep.information_field10 || ""),
    panel: String(dep.information_field11 || ""),
    secondR2From: String(dep.information_field12 || ""),
    secondR2To: String(dep.information_field13 || ""),
    secondR3From: String(dep.information_field14 || ""),
    secondR3To: String(dep.information_field15 || ""),
    outD1R2From: String(dep.information_field16 || ""),
    outD1R2To: String(dep.information_field17 || ""),
    outD2R2From: String(dep.information_field18 || ""),
    outD2R2To: String(dep.information_field19 || ""),
  };
})

  setSvList(existingSVs);

  if (existingSVs.length > 0) {
    setLocalSelectedSV(0);
  }
}, [project, svList.length]);
const [openSnackbar, setOpenSnackbar] = useState(false);
 const [alertType, setAlertType] = useState("success");
 const [alertMsg, setAlertMsg] = useState("");
  const inputStyle = {
    width: "100%",
    height: "35px",
    padding: "5px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  };
  const labelStyle = {
    display: "block",
    marginBottom: "5px",
    fontWeight: "600",
    fontSize: "13px",
  };

  const currentSV = svList[localSelectedSV] || {};
  const handleSVSelect = (svName) => {
    setLocalSelectedSV(0);

    setSvList([
      {
        id: Date.now(),
        name: svName,
      },
    ]);



  };
  const update = (key, value) => {
    setSvList((prev) => {
      const updated = [...prev];
      if (!updated[localSelectedSV]) return prev;
      updated[localSelectedSV] = {
        ...updated[localSelectedSV],
        [key]: value,
      };
      return updated;
    });
  };

  const handleAddSV = () => {
    const freshProject = JSON.parse(
      sessionStorage.getItem("selectedProject")
    );

const dependencyArray =
  freshProject?.selectedPanel?.VT5000_CONFIG?.Dependency ||
  freshProject?.selectedPanel?.VT5000_CONFIG?.dependency ||
  freshProject?.panel?.VT5000_CONFIG?.Dependency ||
  freshProject?.panel?.VT5000_CONFIG?.dependency ||
  [];

    
    let dependencyIndex = dependencyArray.findIndex(
      (d) => d.dependencyType === 0
    );


    if (dependencyIndex === -1) {
      dependencyIndex = dependencyArray.length;

      dependencyArray.push({
        dependencyType: 0,
        information_field1: 0,
        information_field2: 0,
        information_field3: 0,
        information_field4: 0,
        information_field5: 0,
        information_field6: 0,
        information_field7: 0,
        information_field8: 0,
        information_field9: 0,
        information_field10: 0,
        information_field11: 0,
        information_field12: 0,
        information_field13: 0,
        information_field14: 0,
        information_field15: 0,
        information_field16: 0,
        information_field17: 0,
        information_field18: 0,
        information_field19: 0,
      });
    }

    const newSV = {
      id: Date.now(),
      name: `SV${svList.length + 1}`,
      dependencyIndex,
       dependencyType: dependencyType,
       inhibitionPeriod: 10,
  smartVerifyPeriod: 1,
  includedZoneFrom: 1,
  includedZoneTo: 1,
  firstFireOutputFrom: 1,
  firstFireOutputTo: 1,
  outputFrom: 1,
  outputTo: 1,
      zone1: "",
      zone2: "",
      d1: 0,
      d2: 0,
      outD1R1From: "",
      outD1R1To: "",
      outD2R1From: "",
      outD2R1To: "",
      secondR1From: "",
      secondR1To: "",
      panel: "",
      secondR2From: "",
      secondR2To: "",
      secondR3From: "",
      secondR3To: "",
      outD1R2From: "",
      outD1R2To: "",
      outD2R2From: "",
      outD2R2To: "",
    };

    setSvList((prev) => [...prev, newSV]);

    freshProject.panel.VT5000_CONFIG.Dependency = dependencyArray;

    sessionStorage.setItem(
      "selectedProject",
      JSON.stringify(freshProject)
    );

    setProject(freshProject);
  };
  const [selectedDependency, setSelectedDependency] = useState(0);
 const dependencyType = currentSV?.dependencyType || 0;
  const savedPanel = sessionStorage.getItem("panelContentId") || "";


  const handleSave = async () => {
    try {
      // fresh project
      const freshProject = JSON.parse(
        sessionStorage.getItem("selectedProject")
      );

      if (!freshProject) {
        console.error("Project not found");
        return;
      }

      // deep clone dependency array
     const dependencyArray = JSON.parse(
  JSON.stringify(
    freshProject?.selectedPanel?.VT5000_CONFIG?.Dependency ||
    freshProject?.selectedPanel?.VT5000_CONFIG?.dependency ||
    freshProject?.panel?.VT5000_CONFIG?.Dependency ||
    freshProject?.panel?.VT5000_CONFIG?.dependency ||
    []
  )
);

      // ALWAYS use refs here
      const activeSV =
        svListRef.current[localSelectedSVRef.current];

      if (!activeSV) {
        console.error("No active SV found");
        return;
      }

      const index = activeSV.dependencyIndex;

      if (
        index === undefined ||
        index === null ||
        !dependencyArray[index]
      ) {
        console.error("Invalid dependency index:", index);
        return;
      }
 setOpenSnackbar(true);
      // dependency object
      const dep = {
        ...dependencyArray[index],
      };

      const setVal = (v) =>
        v !== undefined &&
          v !== null &&
          v !== ""
          ? Number(v)
          : 0;

      // update values
   dep.dependencyType = activeSV.dependencyType;
if (activeSV.dependencyType === 1 || activeSV.dependencyType === 2) {
  dep.information_field1 = setVal(activeSV.inhibitionPeriod);
  dep.information_field2 = setVal(activeSV.smartVerifyPeriod);
  dep.information_field3 = setVal(activeSV.includedZoneFrom || activeSV.zone1);
  dep.information_field4 = setVal(activeSV.includedZoneTo || activeSV.zone2);
  dep.information_field5 = setVal(activeSV.firstFireOutputFrom || activeSV.outputFrom);
  dep.information_field6 = setVal(activeSV.firstFireOutputTo || activeSV.outputTo);
} else if (activeSV.dependencyType === 3) {
      dep.information_field1 = setVal(activeSV.zone1);
      dep.information_field2 = setVal(activeSV.zone2);
      dep.information_field3 = setVal(activeSV.d1);
      dep.information_field4 = setVal(activeSV.d2);

      dep.information_field5 = setVal(activeSV.outD1R1From);
      dep.information_field6 = setVal(activeSV.outD1R1To);

      dep.information_field7 = setVal(activeSV.outD2R1From);
      dep.information_field8 = setVal(activeSV.outD2R1To);

      dep.information_field9 = setVal(activeSV.secondR1From);
      dep.information_field10 = setVal(activeSV.secondR1To);

      dep.information_field11 = setVal(
        activeSV.panel || panelAddress
      );

      dep.information_field12 = setVal(activeSV.secondR2From);
      dep.information_field13 = setVal(activeSV.secondR2To);

      dep.information_field14 = setVal(activeSV.secondR3From);
      dep.information_field15 = setVal(activeSV.secondR3To);

      dep.information_field16 = setVal(activeSV.outD1R2From);
      dep.information_field17 = setVal(activeSV.outD1R2To);

      dep.information_field18 = setVal(activeSV.outD2R2From);
      dep.information_field19 = setVal(activeSV.outD2R2To);
    }
      
      dependencyArray[index] = dep;

    
      freshProject.panel.VT5000_CONFIG.Dependency =
        dependencyArray;

     
      delete freshProject.panel.VT5000_CONFIG.dependency;

    
      sessionStorage.setItem(
        "selectedProject",
        JSON.stringify(freshProject)
      );

      setProject(freshProject);

      const payload = {
        projectId: freshProject.project_id,
        panelContentId:
          sessionStorage.getItem("panelContentId"),
        dependency: dependencyArray,
        email: localStorage.getItem("userEmail"),
      };

      console.log(
        "FINAL PAYLOAD",
        JSON.stringify(payload, null, 2)
      );

      // API call
      const response = await Axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/update_panel_dependency`,
        payload
      );

      console.log("API RESPONSE:", response.data);
      console.log(
        dependencyArray.filter(d => d.dependencyType === 3)
      );
           setAlertMsg("Dependecy save saved successfully");
        setAlertType("success");

      // handleSaveCell(
      //   "SV",
      //   localSelectedSVRef.current
      // );


 setOpenSnackbar(false);
    } catch (error) {
      console.error("SAVE ERROR:", error);
    }
  };
  const handleDelete = async () => {
  const freshProject = JSON.parse(sessionStorage.getItem("selectedProject"));

  const dependencyArray =
    freshProject?.selectedPanel?.VT5000_CONFIG?.Dependency ||
    freshProject?.selectedPanel?.VT5000_CONFIG?.dependency ||
    freshProject?.panel?.VT5000_CONFIG?.Dependency ||
    freshProject?.panel?.VT5000_CONFIG?.dependency ||
    [];

  const activeSV = svList[localSelectedSV];

  if (!activeSV) return;

  // Remove dependency
  dependencyArray.splice(activeSV.dependencyIndex, 1);

  // Remove SV from UI
  const updatedSVList = svList.filter((_, i) => i !== localSelectedSV);
  setSvList(updatedSVList);

  // Save back
  freshProject.panel.VT5000_CONFIG.Dependency = dependencyArray;

  sessionStorage.setItem(
    "selectedProject",
    JSON.stringify(freshProject)
  );

  await Axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/update_panel_dependency`,
    {
      projectId: freshProject.project_id,
      panelContentId: sessionStorage.getItem("panelContentId"),
      dependency: dependencyArray,
      email: localStorage.getItem("userEmail"),
    }
  );
};
  return (
    <div style={{ width: "100%", padding: "10px" }}>
<div style={{ display: "flex", gap: "10px", margin: "15px 0" }}>
  {[1, 2, 3].map((type,index) => (
    <button
      key={type}
     onClick={() => {
     update("dependencyType", type)
    }}
          style={{
        padding: "8px 20px",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        background: dependencyType === type ? "#007bff" : "#eee",
        color: dependencyType === type ? "#fff" : "#000",
      }}
    >
        {["A", "B", "C"][index]} 
    </button>
  ))}
</div>

      <div   style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(60px, 1fr))",
    gap: "10px",
    marginBottom: "10px",
  }}>

        {svList.map((sv, index) => {

          const svName = `SV${index + 1}`;
          return (
            <button
              key={svName}
              onClick={() => {
                setLocalSelectedSV(index);
                
              }}
              style={{
                  width: "50px",
          height: "30px",
                background:
                  localSelectedSV === index
                    ? "#007bff"
                    : "#eee",
                color:
                  localSelectedSV === index
                    ? "#fff"
                    : "#000",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "12px",
              }}
            >
              {svName}
            </button>
          );
        })}


        <button
          onClick={handleAddSV}
          style={{
              width: "80px",
          height: "30px",
            padding: "6px 10px",
            background: "green",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "12px",
          }}
        >
          + Add SV
        </button>

      </div>


{dependencyType === 1 && (
  <>
    <div style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
        marginBottom: "15px",
      }}>
      <div style={{ width: "180px", fontSize: "14px" }}>Inhibition Period</div>
      <select  style={{
          flex: 1,
          height: "35px",
          borderRadius: "5px",
          padding: "5px",
        }}
        value={currentSV?.inhibitionPeriod || 10}
        onChange={(e) =>
          update("inhibitionPeriod", e.target.value)
        }
      >
        {[10,20,30,40,50].map((sec) => (
          <option key={sec} value={sec}>
            {sec} Sec
          </option>
        ))}
      </select>
    </div>

    <div
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
        marginBottom: "15px",
      }}
    >
      <div style={{ width: "180px", fontSize: "14px" }}>
        Smart Verify Period
      </div>
      <select style={{
          flex: 1,
          height: "35px",
          borderRadius: "5px",
          padding: "5px",
        }}
        value={currentSV?.smartVerifyPeriod || 1}
        onChange={(e) =>
          update("smartVerifyPeriod", e.target.value)
        }
      >
        {Array.from({ length: 30 }, (_, i) => (
          <option key={i + 1} value={i + 1}>
            {i + 1} Min
          </option>
        ))}
      </select>
    </div>

   <div
  style={{
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginBottom: "15px",
  }}
>
  <div style={{ width: "180px", fontSize: "14px" }}>
    Included Zones
  </div>

  <select
    value={currentSV?.includedZoneFrom || 1}
    onChange={(e) =>
      update("includedZoneFrom", e.target.value)
    }
    style={{
      flex: 1,
      height: "35px",
      borderRadius: "5px",
      padding: "5px",
    }}
  >
    {Array.from({ length: 192 }, (_, i) => (
      <option key={i + 1} value={i + 1}>
        {i + 1}
      </option>
    ))}
  </select>

  <span>To</span>

  <select
    value={currentSV?.includedZoneTo || 1}
    onChange={(e) =>
      update("includedZoneTo", e.target.value)
    }
    style={{
      flex: 1,
      height: "35px",
      borderRadius: "5px",
      padding: "5px",
    }}
  >
    {Array.from({ length: 192 }, (_, i) => (
      <option key={i + 1} value={i + 1}>
        {i + 1}
      </option>
    ))}
  </select>
</div>

     

    <div
  style={{
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginBottom: "15px",
  }}
>
  <div style={{ width: "180px", fontSize: "14px" }}>
    First Fire Output
  </div>

  <select
    style={{
      flex: 1,
      height: "35px",
      borderRadius: "5px",
      padding: "5px",
    }}
    value={currentSV?.firstFireOutputFrom || 1}
    onChange={(e) =>
      update("firstFireOutputFrom", e.target.value)
    }
  >
    <option value={0}>0</option>
    {Array.from({ length: 192 }, (_, i) => (
      
      <option key={i + 1} value={i + 1}>
        {i + 1}
      </option>
    ))}
  </select>

  <span>To</span>

  <select
    style={{
      flex: 1,
      height: "35px",
      borderRadius: "5px",
      padding: "5px",
    }}
    value={currentSV?.firstFireOutputTo || 1}
    onChange={(e) =>
      update("firstFireOutputTo", e.target.value)
    }
  >
    <option value={0}>0</option>
    {Array.from({ length: 192 }, (_, i) => (
      <option key={i + 1} value={i + 1}>
        {i + 1}
      </option>
    ))}
  </select>
</div>
 
  </>
)}


{dependencyType === 2 && (
  <>
    <b>Inhibition SV{localSelectedSV + 1}</b>
    
    <div
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
        marginBottom: "15px",
      }}
    >
      <div style={{ width: "180px", fontSize: "14px" }}>
        Inhibition Period
      </div>

      <select
        value={currentSV?.inhibitionPeriod || 10}
        onChange={(e) =>
          update("inhibitionPeriod", Number(e.target.value))
        }
        style={{
          flex: 1,
          height: "35px",
          borderRadius: "5px",
          padding: "5px",
        }}
      >
        {Array.from({ length: 23 }, (_, i) => {
          const value = (i + 1) * 10;
          return (
            <option key={value} value={value}>
              {value} Sec
            </option>
          );
        })}
      </select>
    </div>

    <div
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
        marginBottom: "15px",
      }}
    >
      <div style={{ width: "180px", fontSize: "14px" }}>
        Smart Verify Period
      </div>

      <select
        value={currentSV?.smartVerifyPeriod || 30}
        onChange={(e) =>
          update("smartVerifyPeriod", Number(e.target.value))
        }
        style={{
          flex: 1,
          height: "35px",
          borderRadius: "5px",
          padding: "5px",
        }}
      >
       {Array.from({ length: 30 }, (_, i) => (
          <option key={i + 1} value={i + 1}>
            {i + 1} Min
          </option>
        ))}
      </select>
    </div>

    <div
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
        marginBottom: "15px",
      }}
    >
      <div style={{ width: "180px", fontSize: "14px" }}>
        Included Zones
      </div>

      <select
        value={currentSV?.zone1 || ""}
        onChange={(e) => update("zone1", e.target.value)}
          style={{ flex: 1, height: "35px" }}
      >
        {[...Array(192)].map((_, i) => (
          <option key={i + 1} value={i + 1}>
            {i + 1}
          </option>
        ))}
      </select>

      <span>To</span>

      <select
        value={currentSV?.zone2 || ""}
        onChange={(e) => update("zone2", e.target.value)}
        style={{ flex: 1, height: "35px" }}
      >
        {[...Array(192)].map((_, i) => (
          <option key={i + 1} value={i + 1}>
            {i + 1}
          </option>
        ))}
      </select>
    </div>

    <div
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
        marginBottom: "15px",
      }}
    >
      <div style={{ width: "180px", fontSize: "14px" }}>
        First Fire Output
      </div>

      <select
        value={currentSV?.firstFireOutputFrom || ""}
        onChange={(e) => update("firstFireOutputFrom", e.target.value)}
        style={{ flex: 1, height: "35px" }}
      >
        <option value={0}>0</option>
        {[...Array(192)].map((_, i) => (
          <option key={i + 1} value={i + 1}>
            {i + 1}
          </option>
        ))}
      </select>

      <span>To</span>

      <select
        value={currentSV?.outputTo || ""}
        onChange={(e) => update("outputTo", e.target.value)}
        style={{ flex: 1, height: "35px" }}
      >
        <option value={0}>0</option>
        {[...Array(192)].map((_, i) => (
          <option key={i + 1} value={i + 1}>
            {i + 1}
          </option>
        ))}
      </select>
    </div>
  </>
)}

      {dependencyType === 3 && (
        <>
      <b>Smart Verify SV{localSelectedSV + 1}</b>
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >
        <div style={{ width: "180px", fontSize: "14px" }}>
          Includes Zones
        </div>


        <select
          value={currentSV?.zone1 || ""}
          onChange={(e) => update("zone1", e.target.value)}
          style={{
            flex: 1,
            height: "35px",
            borderRadius: "5px",
            padding: "5px",
          }}
        >

          {[...Array(192)].map((_, i) => (
            <option key={i + 1} value={String(i + 1)}>
              {i + 1}
            </option>
          ))}
        </select>
        <select
          value={currentSV?.zone2 || ""}
          onChange={(e) => update("zone2", e.target.value)}
          style={{
            flex: 1,
            height: "35px",
            borderRadius: "5px",
            padding: "5px",
          }}
        >

          {[...Array(192)].map((_, i) => (
            <option key={i + 1} value={String(i + 1)}>
              {i + 1}
            </option>
          ))}
        </select>

        <input
          value={savedPanel}
          onChange={(e) => update("panel", e.target.value)}
          style={{
            flex: 1,
            height: "35px",
            padding: "5px",
            borderRadius: "5px",
            border: "1px solid #ccc",
          }}
        />

      </div>

      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >


        <div style={{ width: "180px", fontSize: "14px" }}>
          1st Fire D1
        </div>

        <select
          value={String(currentSV?.d1 ?? 0)}
          onChange={(e) =>
            update("d1", Number(e.target.value))
          }
          style={{
            flex: 1,
            height: "35px",
            borderRadius: "5px",
            padding: "5px",
          }}
        >
          {Array.from({ length: 43 }, (_, i) => {
            const value = i * 10;

            return (
              <option key={value} value={value}>
                {value} Sec
              </option>
            );
          })}
        </select>


        <div style={{ width: "180px", fontSize: "14px" }}>
          1st Fire D2
        </div>

        <select
          value={String(currentSV?.d2 ?? 0)}
          onChange={(e) =>
            update("d2", Number(e.target.value))
          }
          style={{
            flex: 1,
            height: "35px",
            borderRadius: "5px",
            padding: "5px",
          }}
        >
          {Array.from({ length: 43 }, (_, i) => {
            const value = i * 10;

            return (
              <option key={value} value={value}>
                {value} Sec
              </option>
            );
          })}
        </select>

      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px", }}>
        <div style={{ width: "180px", fontSize: "14px" }}>
          1st Fire Out (D1) R1
        </div>
        <select value={currentSV?.outD1R1From ?? ""} onChange={(e) => update("outD1R1From", e.target.value)}
          style={{ flex: 1, height: "35px", borderRadius: "5px", }}>

          {[...Array(256)].map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
        <span>To</span>
        <select value={currentSV?.outD1R1To ?? ""} onChange={(e) => update("outD1R1To", e.target.value)} style={{
          flex: 1,
          height: "35px", borderRadius: "5px",
        }}>

          {[...Array(256)].map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px", }}>
        <div style={{ width: "180px", fontSize: "14px" }}>
          1st Fire Out (D2) R1

        </div>
        <select value={currentSV?.outD2R1From ?? ""} onChange={(e) => update("outD2R1From", e.target.value)}
          style={{ flex: 1, height: "35px", borderRadius: "5px", }}>

          {[...Array(256)].map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
        <span>To</span>
        <select value={currentSV?.outD2R1To ?? ""} onChange={(e) => update("outD2R1To", e.target.value)} style={{
          flex: 1,
          height: "35px", borderRadius: "5px",
        }}>

          {[...Array(256)].map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px", }}>
        <div style={{ width: "180px", fontSize: "14px" }}>
          1st Fire Out (D1) R2
        </div>
        <select value={currentSV?.outD1R2From ?? ""} onChange={(e) => update("outD1R2From", e.target.value)}
          style={{ flex: 1, height: "35px", borderRadius: "5px", }}>

          {[...Array(256)].map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
        <span>To</span>
        <select value={currentSV?.outD1R2To ?? ""} onChange={(e) => update("outD1R2To", e.target.value)} style={{
          flex: 1,
          height: "35px", borderRadius: "5px",
        }}>

          {[...Array(256)].map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px", }}>
        <div style={{ width: "180px", fontSize: "14px" }}>
          1st Fire Out (D2) R2
        </div>
        <select value={currentSV?.outD2R2From ?? ""} onChange={(e) => update("outD2R2From", e.target.value)}
          style={{ flex: 1, height: "35px", borderRadius: "5px", }}>

          {[...Array(256)].map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
        <span>To</span>
        <select value={currentSV?.outD2R2To ?? ""} onChange={(e) => update("outD2R2To", e.target.value)} style={{
          flex: 1,
          height: "35px", borderRadius: "5px",
        }}>

          {[...Array(256)].map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px", }}>
        <div style={{ width: "180px", fontSize: "14px" }}>
          2nd Fire Out R1
        </div>
        <select value={currentSV?.secondR1From ?? ""} onChange={(e) => update("secondR1From", e.target.value)}
          style={{ flex: 1, height: "35px", borderRadius: "5px", }}>

          {[...Array(256)].map((_, i) => (
            <option key={i + 1} value={String(i + 1)}>
              {i + 1}
            </option>
          ))}
        </select>
        <span>To</span>
        <select value={currentSV?.secondR1To ?? ""} onChange={(e) => update("secondR1To", e.target.value)} style={{
          flex: 1,
          height: "35px", borderRadius: "5px",
        }}>
          {[...Array(256)].map((_, i) => (
            <option key={i + 1} value={String(i + 1)}>
              {i + 1}
            </option>
          ))}
        </select>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px", }}>
        <div style={{ width: "180px", fontSize: "14px" }}>
          2nd Fire Out R2
        </div>
        <select value={currentSV?.secondR2From ?? ""} onChange={(e) => update("secondR2From", e.target.value)}
          style={{ flex: 1, height: "35px", borderRadius: "5px", }}>

          {[...Array(256)].map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
        <span>To</span>
        <select value={currentSV?.secondR2To ?? ""} onChange={(e) => update("secondR2To", e.target.value)} style={{
          flex: 1,
          height: "35px", borderRadius: "5px",
        }}>

          {[...Array(256)].map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px", }}>
        <div style={{ width: "180px", fontSize: "14px" }}>
          2nd Fire Out R3
        </div>
        <select value={currentSV?.secondR3From ?? ""} onChange={(e) => update("secondR3From", e.target.value)}
          style={{ flex: 1, height: "35px", borderRadius: "5px", }}>

          {[...Array(256)].map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
        <span>To</span>
        <select value={currentSV?.secondR3To ?? ""} onChange={(e) => update("secondR3To", e.target.value)} style={{
          flex: 1,
          height: "35px", borderRadius: "5px",
        }}>

          {[...Array(256)].map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
      </div>
</>
        )}
      <div style={{ display: "flex", gap: "10px" }}>

        <button className="add-btn"
          onClick={handleSave}>
          Save
        </button>

        <button className="btn pdf"
         onClick={handleDelete}

        >
          Delete
        </button>

        

      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={alertType}
          variant="filled"
        >
          {alertMsg}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CloudProSVConfig;